import apiBase from './apiBase';

class PermissionsApi {
  static getPermissions() {
    return apiBase.create().get(`/users/permissions`);
  }
}

export default PermissionsApi;
